export default "__VITE_PUBLIC_ASSET__8ec5ae52__"